import styleInject from '../../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".Stack-module_stack__EGeWt{display:flex;gap:var(--spacing-05x)}.Stack-module_stack__EGeWt,.Stack-module_stack__EGeWt *{box-sizing:border-box}.Stack-module_stack__EGeWt.Stack-module_column__kOeTd{flex-direction:column}";
var style = {"stack":"Stack-module_stack__EGeWt","column":"Stack-module_column__kOeTd"};
styleInject(css_248z);

export { style as default };
//# sourceMappingURL=Stack.module.css.js.map
